import {Component, Input, OnInit} from '@angular/core';
import {RouterLink, Router, NavigationEnd, RouterLinkActive} from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { filter } from 'rxjs/operators';
import {environment} from "../../../../environments/environment";
import {SMSGwComponent} from "../../../shared/dialogs/sms-gw/sms-gw.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-header',
  standalone: true,
    imports: [RouterLink, CommonModule, RouterLinkActive],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() isStaging = false;
  isDropdownOpen = false;
  calmeanAccount = {} as any
  selectedItem = 'Dashboard'; // Default value

  constructor(private authService: AuthService, private router: Router, private modalService: NgbModal) {}

  ngOnInit(): void {
    // Track route changes to update the selected item
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const url = event.urlAfterRedirects;
      if (url.includes('/dashboard')) {
        this.selectedItem = 'Dashboard';
      } else if (url.includes('/devices')) {
        this.selectedItem = 'Urządzenia';
      } else if (url.includes('accounts/search')) {
        this.selectedItem = 'Usuwanie konta';
      } else if (url.includes('tools/upload-csv')) {
          this.selectedItem = 'Konfiguracja SIM';
      } else if (url.includes('promo-codes')) {
          this.selectedItem = 'Promo codes';
      } else if (url.includes('device-config/standard')) {
          this.selectedItem = 'Konfiguracja urządzeń';
      } else if (url.includes('change-sim')) {
          this.selectedItem = 'Wymiana karty SIM';
      } else if (url.includes('generation-boxes')) {
          this.selectedItem = 'Wysyłka kart SIM';
      } else if (url.includes('migrationOfCardNumbers')) {
          this.selectedItem = 'Migracja numerów kart';
      } else if (url.includes('searchSim')) {
          this.selectedItem = 'Karty SIM';
      } else if (url.includes('sendPackage')) {
          this.selectedItem = 'Pakowanie';
      } else if (url.includes('/panel')) {
          this.selectedItem = 'Lista urządzeń';
      } else if (url.includes('/configurePayments')) {
          this.selectedItem = 'Konfiguracja płatności';
      }
    });

    // Set initial selected item based on current URL
    const currentUrl = this.router.url;
    if (currentUrl.includes('/dashboard')) {
      this.selectedItem = 'Dashboard';
    } else if (currentUrl.includes('/devices')) {
      this.selectedItem = 'Urządzenia';
    } else if (currentUrl.includes('accounts/search')) {
      this.selectedItem = 'Usuwanie konta';
    } else if (currentUrl.includes('tools/upload-csv')) {
        this.selectedItem = 'Konfiguracja SIM';
    } else if (currentUrl.includes('promo-codes')) {
        this.selectedItem = 'Promo codes';
    } else if (currentUrl.includes('device-config/standard')) {
        this.selectedItem = 'Konfiguracja urządzeń';
    } else if (currentUrl.includes('change-sim')) {
        this.selectedItem = 'Wymiana karty SIM';
    } else if (currentUrl.includes('generation-boxes')) {
        this.selectedItem = 'Wysyłka kart SIM';
    } else if (currentUrl.includes('migrationOfCardNumbers')) {
        this.selectedItem = 'Migracja numerów kart';
    } else if (currentUrl.includes('searchSim')) {
        this.selectedItem = 'Karty SIM';
    } else if (currentUrl.includes('sendPackage')) {
        this.selectedItem = 'Pakowanie';
    } else if (currentUrl.includes('/panel')) {
        this.selectedItem = 'Lista urządzeń';
    } else if (currentUrl.includes('/configurePayments')) {
        this.selectedItem = 'Konfiguracja płatności';
    }

      const calmeanAccountJson = localStorage.getItem('calmeanAccount');
      if (calmeanAccountJson) {
          try {
              this.calmeanAccount = JSON.parse(calmeanAccountJson);
          } catch (err) {
              // If parsing fails, log a warning and keep the raw string as a fallback (implementation step 2)
              console.warn('Unable to parse calmeanAccount JSON from localStorage, falling back to raw value.', err);
              this.calmeanAccount = calmeanAccountJson;
          }
      } else {
          this.calmeanAccount = null;
      }

  }

    hasRight(right: string): boolean {
        const rights = this.calmeanAccount?.rights;
        return Array.isArray(rights) && rights.includes(right);
    }


    smsGW() {
        console.log('smsGw ')

        const modalRef = this.modalService.open(SMSGwComponent, {
            backdrop: 'static',
            keyboard: false,
            size: 'lg'
        });

    }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  setSelectedItem(item: string): void {
      this.isDropdownOpen = false;

      if(item === 'SMSGW') {
          this.smsGW();
          return
      }

    this.selectedItem = item;
  }

  logout(): void {
    this.authService.logout();
    window.location.href = '/login';
  }

    protected readonly environment = environment;
}
